import { render, staticRenderFns } from "./BrigMembers.vue?vue&type=template&id=552d35f6&scoped=true&"
import script from "./BrigMembers.vue?vue&type=script&lang=js&"
export * from "./BrigMembers.vue?vue&type=script&lang=js&"
import style0 from "./BrigMembers.vue?vue&type=style&index=0&id=552d35f6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552d35f6",
  null
  
)

export default component.exports